
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoardResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Board"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board_result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bending_stiffness_CD"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bending_stiffness_MD"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ect"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"grammage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thickness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"burst"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"carbon_footprint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"food_contact_risk"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default_bpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outdated_simulation_parameters"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":244}};
    doc.loc.source = {"body":"fragment BoardResult on Board {\n  board_result {\n    bending_stiffness_CD\n    bending_stiffness_MD\n    ect\n    grammage\n    thickness\n    burst\n    carbon_footprint\n    food_contact_risk\n    default_bpi\n    outdated_simulation_parameters\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/BoardResultFragment.graphql
// module id = lpJ3
// module chunks = 1